import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Zadáte základné údaje",
    text: "Typ budovy, plocha fasády, hrúbka a materiál zateplenia. Jednoducho, za pár klikov.",
    img: "https://images.unsplash.com/photo-1564703048291-bcf7f001d83d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    n: "02",
    title: "Nahráte projekt (voliteľné)",
    text: "Máte projekt domu? Nahrajte PDF alebo fotku — umelá inteligencia z neho odhadne plochu fasády.",
    img: "https://images.pexels.com/photos/36574965/pexels-photo-36574965.jpeg?auto=compress&cs=tinysrgb&w=1000",
  },
  {
    n: "03",
    title: "Prepočet do 60 sekúnd",
    text: "Spočítame materiál, prácu, lešenie aj dopravu. Kompletná orientačná cena okamžite na obrazovke.",
    img: "https://images.unsplash.com/photo-1603239564387-c5b5ea6f635e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    n: "04",
    title: "Realizácia cez partnera v okrese",
    text: "Prepojíme vás s overeným realizátorom vo vašom okrese. Kvalita, na ktorú sa spoľahnete.",
    img: "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
];

export default function Manifesto() {
  return (
    <section id="proces" className="bg-ink py-24 md:py-36 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <p className="font-mono2 text-gold uppercase tracking-[0.3em] text-xs mb-5">Ako to funguje</p>
          <h2 className="font-display text-5xl md:text-7xl leading-[0.9] text-white">
            Od nápadu k hotovej<br /><span className="text-gold">fasáde</span> v štyroch krokoch
          </h2>
        </div>

        <div className="flex flex-col">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className={`grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-center py-10 md:py-14 border-t border-white/10 ${
                i % 2 === 1 ? "md:[direction:rtl]" : ""
              }`}
            >
              <div className="md:col-span-2 [direction:ltr]">
                <span className="font-mono2 text-gold text-2xl md:text-3xl">{c.n}</span>
              </div>
              <div className="md:col-span-5 [direction:ltr]">
                <h3 className="font-display text-3xl md:text-5xl text-white leading-none mb-4">{c.title}</h3>
                <p className="text-white/60 text-base md:text-lg max-w-md leading-relaxed">{c.text}</p>
              </div>
              <div className="md:col-span-5 [direction:ltr]">
                <div className="relative aspect-[16/10] overflow-hidden border border-white/10 group">
                  <img
                    src={c.img}
                    alt={c.title}
                    className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gold/0 group-hover:bg-gold/10 transition-colors" />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
